$(document).on('click', '.kh-copy-link', function (e) {
    e.preventDefault();
    var url = $(this).data('url');
    navigator.clipboard.writeText(url).then(function () {
        show_ajax_notice('Link copied to clipboard!');
    }, function (err) {
        if (window.rollbar) window.rollbar.error('Could not copy link: ', err);
    });
});
